module.exports = __webpack_public_path__ + "img/np-logo.b7aefce0.svg";